<template>
  <div></div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import { Auth } from "aws-amplify";

export default {
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  }
};
</script>
